import { useState, useEffect } from 'react';
import { getAdminSettings } from '../services/api';
import { AdminSettings } from '../types';

interface CompanySettings {
  name: string;
  logoUrl: string;
  email: string;
  phone: string;
}

export const useCompanySettings = () => {
  const [settings, setSettings] = useState<CompanySettings>({
    name: 'Bounce Dads',
    logoUrl: '/logo.png',
    email: 'support@bouncedadsatl.com',
    phone: '(404) 955-8165'
  });
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const fetchSettings = async () => {
      try {
        const adminSettings = await getAdminSettings();
        setSettings({
          name: adminSettings.company_name || 'Bounce Dads',
          logoUrl: adminSettings.company_logo_url || '/logo.png',
          email: adminSettings.support_email || 'support@bouncedadsatl.com',
          phone: adminSettings.contact_phone || '(404) 955-8165'
        });
      } catch (error) {
        console.error('Error fetching company settings:', error);
        // Keep default values on error
      } finally {
        setLoading(false);
      }
    };

    fetchSettings();
  }, []);

  return { settings, loading };
};
